<template>
  <div
    :class="['plv-ia-checkbox', `plv-ia-checkbox--${theme}`]"
  >
    <input
      :id="checkboxId"
      type="checkbox"
      :index="index"
      :name="name"
      :value="value"
      :required="required"
      :disabled="disabled"
      :checked="shouldBeChecked()"
      @change="updateInput"
    />
    <label :for="checkboxId" :cannot-check="cannotCheck">
      <slot></slot>
    </label>
  </div>
</template>

<script>
export default {
  name: 'CommonCheckbox',
  model: {
    prop: 'modelValue',
    event: 'change'
  },

  props: {
    id: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: null,
    },
    value: {
      type: [String, Boolean],
      default: null,
    },
    modelValue: {
      type: [Boolean, Array],
      default: undefined,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
    cannotCheck: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: '',
    }
  },

  data() {
    return {
      checkboxId: '',
    };
  },

  watch: {
    checked(newValue) {
      if (newValue !== this.shouldBeChecked()) {
        this.toggle();
      }
    }
  },

  beforeMount() {
    const fingerprint = `checkbox-${new Date().getTime() % 1000}-${Math.floor(Math.random() * 100000)}`;
    this.checkboxId = this.id || fingerprint;
  },

  mounted() {
    if (this.checked && !this.shouldBeChecked()) {
      this.toggle();
    }
  },

  methods: {
    shouldBeChecked() {
      if (this.modelValue === undefined) {
        return this.checked;
      }

      if (Array.isArray(this.modelValue)) {
        return this.modelValue.indexOf(this.value) > -1;
      }

      return !!this.modelValue;
    },

    updateInput(event) {
      const isChecked = event.target.checked;
      // this.m_checked = isChecked;
      this.toggle(isChecked);
    },

    toggle(isChecked) {
      if (this.modelValue instanceof Array) {
        const newValue = [...this.modelValue];

        if (isChecked) {
          newValue.push(this.value);
        } else {
          newValue.splice(newValue.indexOf(this.value), 1);
        }

        this.$emit('change', newValue, this.id, this.index);
      } else {
        this.$emit('change', isChecked, this.id, this.index);
      }
    }
  },
};
</script>

<style lang="scss">
$height: 16px;

.plv-ia-checkbox {
  height: $height;
  display: inline-block;
  vertical-align: middle;
  margin-right: 8px;

  > input {
    opacity: 0;
    position: absolute;
    height: $height;
    cursor: pointer;

    + label {
      height: $height;
      line-height: $height;
      vertical-align: top;
      color: #333;
      cursor: pointer;
      position: relative;
      padding-left: $height + 6px;

      &:before {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        top: 0;
        margin: auto;

        border: 1px solid #CFD8DC;
        border-radius: 2px;
        width: $height;
        height: $height;
        background: #fff;
        user-select: none;
        box-sizing: border-box;
      }

      &:hover:before {
        border-color: #2196F3;
      }
    }

    &:checked + label:before {
      border: 0;
      background: url(./images/icon-checked.png) no-repeat center;
      background-color: #0097EF;
      background-size: contain;
    }

    &:disabled {
      cursor: not-allowed;
    }

    &:disabled + label {
      opacity: 0.7;
      cursor: not-allowed;

      &::before {
        border-color: #CFD8DC;
      }
    }
  }
}

@mixin smallSize($theme, $fColor, $bgColor, $bgColorHov, $bgColorChk, $bgColorChkHov, $bColor, $bColorHov, $bColorChk, $bColorChkHov) {
  // 未选中状态
  & >input+label {
    padding-left: 12px + 4px;
    color: $fColor;

    &:before {
      width: 10px;
      height: 10px;
      border: 1px solid;

      background-color: $bgColor;
      border-color: $bColor;
    }
  }

  // 选中状态
  & >input:checked+label:before {
    background-image: url(./images/icon-checked-#{$theme}.png);

    background-color: $bgColorChk;
    border-color: $bColorChk;
  }

  &:hover {
    // 未选中状态-hover
    & >input+label:before {
      background-color: $bgColorHov;
      border-color: $bColorHov;
    }

    // 选中状态-hover
    & >input:checked+label:before {
      background-color: $bgColorChkHov;
      border-color: $bColorChkHov;
    }
  }
}

.plv-ia-checkbox--black {
  @include smallSize('black', #ADADC0, #3E3E4E, #524F5E, #3E3E4E, #524F5E, #3E3E4E, #524F5E, #3E3E4E, #524F5E);
}

.plv-ia-checkbox--white {
  @include smallSize('white', #888888, transparent, transparent, #4991E2, rgba(#4991E2, 0.8), #CCCED4, #4991E2, #4991E2, rgba(#4991E2, 0.8));
}

.plv-ia-checkbox--black2 {
  @include smallSize('black2', rgba(#fff, .6), transparent, transparent, #67B5FF, #67B5FF, rgba(#fff, .6), #67B5FF, #67B5FF, #67B5FF);
}
</style>
